import React, { useEffect } from 'react';
import _get from 'lodash/get';
import { useData } from 'resift';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { useDispatch } from 'react-redux';
import makeGetSource from 'fetches/makeGetSource';
import CircularProgress from '@material-ui/core/CircularProgress';

import Wizard from './Wizard';

function Container() {
  const classes = useStyles();
  const { search } = useLocation();
  const query = queryString.parse(search);
  const href = window.location.href;

  const directoryIdUrlMatch = href.includes('create-source')
    ? href.match(/directories\/.*\/create-source/)
    : href.match(/directories\/.*\/source/);
  const directoryId = directoryIdUrlMatch ? directoryIdUrlMatch[0].split('/')[1] : null;

  const sourceIdUrlMatch = href.match(/source\/.*\//);
  const sourceId = sourceIdUrlMatch ? sourceIdUrlMatch[0].split('/')[1] : '';

  const dispatch = useDispatch();
  const getSource = makeGetSource(sourceId);
  const sourceData = useData(getSource);

  useEffect(() => {
    Boolean(sourceId) && dispatch(getSource());
  }, [sourceId]);

  if (Boolean(sourceId) && !sourceData) {
    return (
      <div className={classes.loading}>
        <CircularProgress color="secondary" />
      </div>
    );
  }

  const sourceState = {
    name: _get(sourceData, 'label', ''),
    type: _get(sourceData, 'type', null),
    isPrimary: _get(sourceData, 'isPrimary', query.isPrimarySource === 'true' || !directoryId),
    directoryId: directoryId || null,
    sourceId: sourceId || null,
    fields: _get(sourceData, 'fields', {}),
  };

  return <Wizard sourceState={sourceState} />;
}

const useStyles = makeStyles(theme => {
  return {
    loading: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
});

export default Container;
